// helpers.
const status = ['Baja (60d)', 'Media baja (30d)', 'Media alta (7d)', 'Alta (2d)']

// main function.
const priorityFormat = (num) => {
  return status[num]
}

export default priorityFormat
